/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
    initPopupShippingCountries();
    initPopupAccount();
    initPopupVideo();
    validateFormNewsletterPopup();
    validateFormNewsletterFooter();
    showOnlyVariantsPreOrderProductPage();
    showOnlyVariantsNotPreOrderProductPage();
    openPopupNewsletter();
    checkIfAllChildElementAreHiddenPreOrderProductPage();
    checkIfAllChildElementAreHiddenNotPreOrderProductPage();
    openPopupCookies();
    hidePopupNewsletterOnChallengePage();
    showPopupNewsletterAfterRegistration();
    validateFormCustomerAddressAdd();
    openModalAddress();
    initMegaMenuDesktop();
    initGetAvailableDescriptionFromMetafieldsProductPage();
    hideMainMenuHpVideo();
    scrollHpVideo();
    buildGallery();
    hideTaxesLabelonCh();
    showSizeOnMouseover();
    centerProductArrows();
});

document.addEventListener('variant:changed', function(event) {
    changeLabelButtonAddToCartFromInventory(event);
    updateAvailableDescriptionFromMetafieldsProductPage(event);
});

document.addEventListener('scroll', function() {
    toggleMainMenu();
});

function hideMainMenuHpVideo() {
    var body = $('body');
    var video = $('.section--video-fullscreen');
    var header = $('#section-header');
    var menuVisibleClass = 'Header--menu-hidden';
    if (body.hasClass('template-index') && video.length > 0) {
        header.addClass(menuVisibleClass);
    }
}

function toggleMainMenu() {
    var body = $('body');
    var header = $('#section-header');
    var headerHeight = header.outerHeight();
    var menuVisibleClass = 'Header--menu-hidden';
    if (body.hasClass('template-index')) {
        var video = $('.section--video-fullscreen');
        if (video.length > 0) {
            var scroll = $(window).scrollTop();
            if (scroll >= headerHeight) {
                header.removeClass(menuVisibleClass);
            } else {
                header.addClass(menuVisibleClass);
            }
        }
    }
}

function scrollHpVideo() {
    var html = $('html, body');
    var body = $('body');
    var cta = $('.video-cta');
    if (body.hasClass('template-index') && cta.length > 0) {
        cta.click(function() {
            var parent = $(this).parents('.shopify-section');
            var nextElement = parent.next();
            var nextElementPosition = nextElement.position().top;
            html.animate({scrollTop:nextElementPosition});
        });
    }
}

function updateAvailableDescriptionFromMetafieldsProductPage (event) {
    // Current variant
    var variant = event.detail.variant;
    var current_variant_id = variant.id;
    // Product json
    var productJson = $.parseJSON($('[data-product-json]').text());
    // Current variant
    var variant = event.detail.variant;
    var current_variant_id = variant.id;
    // Mi ricavo i dati dell'inventario della variante corrente
    var variant_inventories = productJson.inventories[current_variant_id];
    var available_description = variant_inventories.available_description;
    // Variant checked
    var variant_checked = $('.SizeSwatch__Radio:checked');
    var parent_variant_checked_id = variant_checked.parent().parent().attr('id');

    // Cambio il valore del metafields "available_description" solo se clicco su una variante in pre-order
    if (parent_variant_checked_id == 'cnt-variants-preorder') {
        if (available_description != null) {
            if (available_description.includes('|')) {
                var dates = available_description.split('|')
                var initialDate = dates[0].trim()
                var endDate = dates[1].trim()
                var initialDateIso = initialDate.split('/').reverse().join('-');
                var endDateIso = endDate.split('/').reverse().join('-');
                var initialDateDef = new Date(initialDateIso)
                var endDateDef = new Date(endDateIso)
                var initialDateYear = initialDateDef.getFullYear()
                var endDateYear = endDateDef.getFullYear()
                if (initialDateYear == 2000 || endDateYear == 2000) {
                    $('.title_box_preorder_variants').hide();
                } else {
                    $('.title_box_preorder_variants').show();
                    $('.title_box_preorder_variants .available-label').text('PRE-ORDER in arrival between')
                    $('.title_box_preorder_variants > span').text(moment(initialDateDef).format('MMMM Do YYYY')+' - '+moment(endDateDef).format('MMMM Do YYYY'));
                }
            } else {
                var iso_date = available_description.split('/').reverse().join('-');
                $('.title_box_preorder_variants .available-label').text('Available within:')
                $('.title_box_preorder_variants > span').text(moment(new Date(iso_date)).format('MMMM Do YYYY'));
            }
        }
    }

}

function buildGallery() {
    var gallery = $('.slider-images-look');
    if (gallery && gallery.length > 0) {
        gallery.slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });
    }
}

function initGetAvailableDescriptionFromMetafieldsProductPage () {
    if ($('[data-product-json]').length == 0) {
        return;
    }
    // Product json
    var productJson = $.parseJSON($('[data-product-json]').text());
    var variantsJson = productJson.product.variants;
    var inventoriesJson = productJson.inventories;
    var variant_checked = $('.SizeSwatch__Radio:checked');
    var parent_variant_checked_id = variant_checked.parent().parent().attr('id');
    // Se la variante corrente non è in pre-order, allora stampo il metafields della prima variante in pre-order
    if (parent_variant_checked_id == 'cnt-variants-not-preorder') {
        var first_variant_in_preorder = $('#cnt-variants-preorder > li:visible').first().children('.SizeSwatch__Radio').val();
        if (first_variant_in_preorder == undefined) {
            return;
        }
        // Cerco la riga della variante a cui appartiene l'opzione
        var variant = variantsJson.find(item => item.title == first_variant_in_preorder);
        // Mi ricavo l'id della variante
        var variant_id = variant.id;
        if (variant_id != '') {
            // Mi ricavo lo stato di inventario della riga variante
            var variant_inventories = inventoriesJson[variant_id];
            var available_description = variant_inventories.available_description;
            if (available_description.includes('|')) {
                var dates = available_description.split('|')
                var initialDate = dates[0].trim()
                var endDate = dates[1].trim()
                var initialDateIso = initialDate.split('/').reverse().join('-');
                var endDateIso = endDate.split('/').reverse().join('-');
                var initialDateDef = new Date(initialDateIso)
                var endDateDef = new Date(endDateIso)
                var initialDateYear = initialDateDef.getFullYear()
                var endDateYear = endDateDef.getFullYear()
                if (initialDateYear == 2000 || endDateYear == 2000) {
                    $('.title_box_preorder_variants').hide();
                } else {
                    $('.title_box_preorder_variants').show();
                    $('.title_box_preorder_variants .available-label').text('PRE-ORDER in arrival between')
                    $('.title_box_preorder_variants > span').text(moment(initialDateDef).format('MMMM Do YYYY')+' - '+moment(endDateDef).format('MMMM Do YYYY'));
                }
            } else {
                var iso_date = available_description.split('/').reverse().join('-');
                var date = new Date(iso_date)
                var dateYear = date.getFullYear()
                if (dateYear == 2000) {
                    $('.title_box_preorder_variants').hide();
                } else {
                    $('.title_box_preorder_variants').show();
                    $('.title_box_preorder_variants .available-label').text('Available within:')
                    $('.title_box_preorder_variants > span').text(moment(date).format('MMMM Do YYYY'));
                }
            }
        }
    } else {
        var available_description = $('.title_box_preorder_variants > span').text();
        if (available_description.includes('|')) {
            var dates = available_description.split('|')
            var initialDate = dates[0].trim()
            var endDate = dates[1].trim()
            var initialDateIso = initialDate.split('/').reverse().join('-');
            var endDateIso = endDate.split('/').reverse().join('-');
            var initialDateDef = new Date(initialDateIso)
            var endDateDef = new Date(endDateIso)
            var initialDateYear = initialDateDef.getFullYear()
            var endDateYear = endDateDef.getFullYear()
            if (initialDateYear == 2000 || endDateYear == 2000) {
                $('.title_box_preorder_variants').hide();
            } else {
                $('.title_box_preorder_variants').show();
                $('.title_box_preorder_variants .available-label').text('PRE-ORDER in arrival between')
                $('.title_box_preorder_variants > span').text(moment(initialDateDef).format('MMMM Do YYYY')+' - '+moment(endDateDef).format('MMMM Do YYYY'));
            }
        } else {
            var iso_date = available_description.split('/').reverse().join('-');
            var date = new Date(iso_date)
            var dateYear = date.getFullYear()
            if (dateYear == 2000) {
                $('.title_box_preorder_variants').hide();
            } else {
                $('.title_box_preorder_variants').show();
                $('.title_box_preorder_variants .available-label').text('Available within:')
                $('.title_box_preorder_variants > span').text(moment(date).format('MMMM Do YYYY'));
            }
        }
    }

}


function initMegaMenuDesktop () {
	var link_primo_livello = $('.link-primo-livello');
	var animatedClass = 'animated';
    var openedClass = 'open';
	link_primo_livello.hover(function () {
	    $(this).children('.cnt_link_secondo_livello').css('display', 'flex').hide().stop().removeClass(animatedClass).fadeIn();
	    var h_cnt_link_secondo_livello = $(this).children('.cnt_link_secondo_livello').outerHeight();
	    $('.wrapper-bkg-main-menu').stop().height(h_cnt_link_secondo_livello+'px');
	}, function () {
	    $(this).children('.cnt_link_secondo_livello').stop().addClass(animatedClass).fadeOut();
	    $('.wrapper-bkg-main-menu').stop().height(0);
	});

	var link_secondo_livello = $('.link-secondo-livello');
	link_secondo_livello.hover(function () {
	    var h_cnt_link_secondo_livello = $(this).outerHeight();
	    $(this).children('.cnt_link_terzo_livello').css('display', 'flex').hide().stop().removeClass(animatedClass).fadeIn();
        var cnt_link_terzo_livello = $(this).children('.cnt_link_terzo_livello');
        if (cnt_link_terzo_livello.length > 0) {
            var h_cnt_link_terzo_livello = $(this).children('.cnt_link_terzo_livello').outerHeight();
            $('.wrapper-bkg-main-menu').stop().addClass(openedClass).height((h_cnt_link_terzo_livello + h_cnt_link_secondo_livello + 25) +'px').show();
        }
	}, function () {
	    $(this).children('.cnt_link_terzo_livello').stop().addClass(animatedClass).fadeOut();
	    $('.wrapper-bkg-main-menu').stop().height(0).removeClass(openedClass);
	});
}



function openModalAddress () {
    var open_modal_address = $('.open_modal_address');
    if (open_modal_address.length <= 0) {
        return;
    }
    open_modal_address.on('click', function () {
        var modal_id = $(this).attr('aria-controls');
        var modal_form = $('#'+modal_id);
        if (modal_form.length <= 0) {
            return;
        }
        var country = modal_form.find('.country');
        if (country.length <= 0) {
            return;
        }
        var country_val = country.val();
        /*
        if (country_val == 'Italy' || country_val == 'italy') {
            $('.fiscal_code').attr('required','required').show();
        } else {
            $('.fiscal_code').removeAttr('required').val('').hide();
        }*/
    });
}

function validateFormCustomerAddressAdd () {

    /*
    // On load page
    var country_val = $('.country').val();
    if (country_val == 'Italy' || country_val == 'italy') {
        $('.fiscal_code').attr('required','required').show();
    } else {
        $('.fiscal_code').removeAttr('required').val('').hide();
    }
    */

    // On change country
    $('.country').on('change', function () {
        var country_val = $(this).val();
        /*
        if (country_val == 'Italy' || country_val == 'italy') {
            $('.fiscal_code').attr('required','required').show();
        } else {
            $('.fiscal_code').removeAttr('required').val('').hide();
        }*/
    });

    // Submit form
    var form = $('#address_form_new');
    form.on('submit', function (event) {
        var valid = false,
            first_name_val = $('.first_name').val(),
            last_name_val = $('.last_name').val(),
            address_val = $('.address').val(),
            fiscal_code_val = $('.fiscal_code').val(),
            city_val = $('.city').val(),
            country_val = $('.country').val(),
            zip_val = $('.zip').val(),
            province_val = $('.province').val(),
            set_default_address_val = $('.set_default_address').val();

        if ($('.fiscal_code').css('display') == 'none') {
            valid = true;
            $('.fiscal_code').val('');
        } else {
            if ( (country_val == 'Italy' || country_val == 'italy') && fiscal_code_val != '') {
                valid = true;
            }
        }

        if (!valid) {
            //event.preventDefault();
        }
    });


    /*
    var select_country = $('#select_country_address_page');
    if (select_country.length <= 0) {
        return;
    }
    // Country on load page
    var country = select_country.val();
    if (country == 'Italy' || country == 'italy') {
        $('#fiscal_code_page_address').attr('required', 'required').show();
    } else {
        $('#fiscal_code_page_address').removeAttr('required').hide();
    }
    // Country on change
    select_country.on('change', function () {
        var country = $(this).val();
        if (country == 'Italy' || country == 'italy') {
            $('#fiscal_code_page_address').attr('required', 'required').show();
        } else {
            $('#fiscal_code_page_address').removeAttr('required').hide();
        }
    });
    // On blur fiscal code
    $('#fiscal_code_page_address').on('blur', function () {
        var fiscal_code_val = $(this).val();
        if (fiscal_code_val != '') {
            $('#btn_submit_form_page_address').removeAttr('disabled');
        } else {
            $('#btn_submit_form_page_address').attr('disabled', 'disabled');
        }
    });
    */

}




function hidePopupNewsletterOnChallengePage () {
    var g_ecaptcha = $('#g-recaptcha');
    if (g_ecaptcha.length == 0) {
        return;
    }
    $('.NewsletterPopup').hide();
}

function showPopupNewsletterAfterRegistration() {
    var customer_posted = getUrlVars()['customer_posted'];
    if (customer_posted == 'true') {
        $('.NewsletterPopup').attr('aria-hidden', 'false');
    }
}

function openPopupCookies() {
    var link = $('.link_open_popup_cookies');
    if (link.length <= 0) {
        return;
    }
    link.on('click', function () {
        document.querySelector('.cc-settings').click();
    });
}

function checkIfAllChildElementAreHiddenPreOrderProductPage() {
    var isVisible = 0;
    $("#cnt-variants-not-preorder li").each(function () {
        if ( $(this).css("display") != "none") {
            isVisible++;
        }
    });
    if ( isVisible > 0 ) {
        $('.ProductFrom__Label_OptionName').show();
    } else {
        $('.ProductFrom__Label_OptionName').hide();
    }
}

function checkIfAllChildElementAreHiddenNotPreOrderProductPage() {
    var isVisible = 0;
    $("#cnt-variants-preorder li").each(function () {
        if ( $(this).css("display") != "none") {
            isVisible++;
        }
    });
    if ( isVisible > 0 ) {
        $('.title_box_preorder_variants').show();
    } else {
        $('.title_box_preorder_variants').hide();
    }
}


function showOnlyVariantsNotPreOrderProductPage() {
    if ($('#cnt-variants-not-preorder').length <= 0) {
        return;
    }
    var variant_id_from_url = getUrlVars()['variant'];
    // Product json
    var productJson = $.parseJSON($('[data-product-json]').text());
    var variantsJson = productJson.product.variants;
    var inventoriesJson = productJson.inventories;
    // Mi ricavo le options
    $('.radio_option_not_preorder').each(function () {
        // Mi ricavo il valore delle options (34, 36, 38, 40...)
        var option_value = $(this).val();
        if (option_value == 'UNI') {
            $(this).next('.SizeSwatch').css('padding-left', '8px');
        }
        // Cerco la riga della variante a cui appartiene l'opzione
        var variant = variantsJson.find(item => item.title == option_value);
        // Mi ricavo l'id della variante
        var variant_id = variant.id;
        if (variant_id != '') {
            // Mi ricavo lo stato di inventario della riga variante
            var variant_inventories = inventoriesJson[variant_id];
            var inventory_policy = variant_inventories.inventory_policy;
            var inventory_quantity = variant_inventories.inventory_quantity;
            var ordinato_a_fornitore = variant_inventories.ordinato_a_fornitore;

            /*
            console.log('Option:', option_value); // 34
            console.log('inventory_policy:', inventory_policy) // deny, continue
            console.log('inventory_qta:', inventory_quantity); // -10
            console.log('ordinato_a_fornitore:', ordinato_a_fornitore); // 5
            */

            if ((inventory_policy == 'deny' && inventory_quantity <= 0) || (inventory_policy == 'continue' && inventory_quantity <= 0)) {
                // console.log('SOLD OUT / PRE ORDER', option_value);
                $(this).parent().hide();
            } else {
                if (variant_id_from_url == variant_id) {
                    $(this).trigger('click');
                }
            }
        }
        // console.log('========');
    });
}

function showOnlyVariantsPreOrderProductPage() {
    if ($('#cnt-variants-preorder').length <= 0) {
        return;
    }
    var variant_id_from_url = getUrlVars()['variant'];
    // Product json
    var productJson = $.parseJSON($('[data-product-json]').text());
    var variantsJson = productJson.product.variants;
    var inventoriesJson = productJson.inventories;
    // Mi ricavo le options
    $('.radio_option_preorder').each(function () {
        // Mi ricavo il valore delle options (34, 36, 38, 40...)
        var option_value = $(this).val();
        if (option_value == 'UNI') {
            $(this).next('.SizeSwatch').css('padding-left', '8px');
        }
        // Cerco la riga della variante a cui appartiene l'opzione
        var variant = variantsJson.find(item => item.title == option_value);
        // Mi ricavo l'id della variante
        var variant_id = variant.id;
        if (variant_id != '') {
            // Mi ricavo lo stato di inventario della riga variante
            var variant_inventories = inventoriesJson[variant_id];
            var inventory_policy = variant_inventories.inventory_policy;
            var inventory_quantity = variant_inventories.inventory_quantity;
            var ordinato_a_fornitore = variant_inventories.ordinato_a_fornitore;

            /*
            console.log('Option:', option_value); // 34
            console.log('inventory_policy:', inventory_policy) // deny, continue
            console.log('inventory_qta:', inventory_quantity); // -10
            console.log('ordinato_a_fornitore:', ordinato_a_fornitore); // 5
            */

            // Sold out
            if (inventory_policy == 'deny') {
                // console.log('SOLD OUT', option_value);
                $(this).parent().hide();
            }
            // Pre order
            else if (inventory_policy == 'continue' && inventory_quantity <= 0 && Math.abs(inventory_quantity) != ordinato_a_fornitore) {
                // console.log('PRE ORDER', option_value);
                $(this).parent().show();
                if (variant_id_from_url == variant_id) {
                    $(this).trigger('click');
                }
            }
            // Sold out (prodotto continuativo)
            else if ( inventory_policy == 'continue' && inventory_quantity <= 0 && Math.abs(inventory_quantity) == ordinato_a_fornitore ) {
                // console.log('SOLD OUT PRODOTTO CONTINUATIVO', option_value);
                $(this).parent().hide();
            }
            else if (inventory_policy == 'continue' && inventory_quantity > 0) {
                // console.log('In STOCK PRODOTTO CONTINUATIVO', option_value);
                $(this).parent().hide();
            }
        }
        // console.log('====');
    });
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

function changeLabelButtonAddToCartFromInventory(event) {
    // Product json
    var productJson = $.parseJSON($('[data-product-json]').text());
    // Current variant
    var variant = event.detail.variant;
    var current_variant_id = variant.id;
    // Mi ricavo i dati dell'inventario della variante corrente
    var inventory_current_variant = productJson.inventories[current_variant_id];
    var inventory_policy_current_variant = inventory_current_variant.inventory_policy;
    var inventory_quantity_current_variant = inventory_current_variant.inventory_quantity;

    /*
    console.log('variant_id', current_variant_id);
    console.log('inventory_policy_current_variant', inventory_policy_current_variant);
    console.log('inventory_quantity_current_variant', inventory_quantity_current_variant);
    console.log('==========');
    */


    // Button add to cart
    var btnAddToCart = $('.ProductForm__AddToCart');
    // Cambio label in "pre order" se la variante è vendibile out of stock
    if (inventory_policy_current_variant == 'continue' && inventory_quantity_current_variant <= 0) {
        btnAddToCart.html('<span>PRE-ORDER</span>');
    }
    // Cambio label in "add to cart" se la variante è disponibile
    else if (inventory_quantity_current_variant > 0) {
        btnAddToCart.html('<span>ADD TO CART</span>');
    }
    // Cambio label in "out of stock" se la variante non è disponibile
    else if (inventory_policy_current_variant == 'deny' && inventory_quantity_current_variant <= 0) {
        btnAddToCart.html('<span>SOLD OUT</span>');
    }

}


function showVariantsBoxProductPage(cnt_el_selector) {
    // Hide text
    $(cnt_el_selector).children().each((idx, elt)=>{
        if ( $(elt).children().css('display') != 'none') {
           return true;
        }
    });
    return false;
}

function initPopupShippingCountries() {
    const link_popup_shipping_countries = $('.link_popup_shipping_countries');
    link_popup_shipping_countries.hover(
        function() {
            $(this).children('.cnt_link_shipping_countries').stop().fadeIn();
        }, function() {
            $(this).children('.cnt_link_shipping_countries').stop().fadeOut();
        }
    );
}

function initPopupAccount() {
    const link_popup_account = $('.link_popup_account');
    link_popup_account.hover(
        function() {
            $(this).children('.cnt_link_account').stop().fadeIn();
        }, function() {
            $(this).children('.cnt_link_account').stop().fadeOut();
        }
    );
}

function initPopupVideo() {
    // Variables
    var videoPageWrapper = $('#shopify-section-ad-video-page'),
        videoIframe = $('#ad-video-page iframe')
        linkToSite = $('#link-to-site'),
        html = $('html'),
        body = $('body'),
        playerVideo = $('#player_video_popup'),
        linkShowVideo = $('.link_show_video');
        hiddenClass = 'disable-scroll-page'

    // Show splash page or video page
    if($('#ad-video-countdown')) {
        //toggleHpVideo()
        $("#ad-video-page, #ad-video-countdown").css({'display': 'none','opacity':'0'});
        const now = Date.now();
        let end_date = $('#ctb_placeholder').attr('data-custom-end-date');
        if(!end_date) { // Fallback - Date in the past
            end_date = 'Jan 01, 2021 00:00';
        }
        const then = new Date(end_date).getTime();
        if (then > now) { // countdown date is in the future, show countdown
            $("#ad-video-countdown").css({'display': 'block','opacity':'1'});
            let countDown;
            countDown = setInterval(() => {
                const secondsLeft = Math.round((then - Date.now()) / 1000);
                if(secondsLeft < 0) {
                    $("#ad-video-countdown").css({'display': 'none','opacity':'0'});
                    $("#ad-video-page").css({'display': 'block','opacity':'1'});
                    clearInterval(countDown);
                    return;
                }
            }, 1000);
        } else {
            $("#ad-video-page").css({'display': 'block','opacity':'1'});
        }
        $( document ).on( 'click', '#link-to-site-splash', function(e) {
            $('#shopify-section-ad-video-page').fadeOut();
            html.removeClass(hiddenClass);
            body.removeClass(hiddenClass);
        });

        if($('body > #shopify-section-ad-video-page' ).length > 0) {
            html.addClass(hiddenClass);
            body.addClass(hiddenClass);
        }
    }

    // Istanza video player
    var player = plyr.setup('#player_video_popup');
    // Controllo se visualizzare la pagina col video
    var showVideoPageForParade = showVideoPage(videoPageWrapper);

    // Show popup video page
    videoPageWrapper.show();

    // Video gia visualizzato
    if (!showVideoPageForParade) {
        videoPageWrapper.hide();
        html.removeClass(hiddenClass);
        body.removeClass(hiddenClass);
        // Video ancora non visualizzato
    } else {
        // Stop scrolling when video page is visible
        html.addClass(hiddenClass);
        body.addClass(hiddenClass);
    }

    // Close video page
    linkToSite.on('click', function () {
        if (player) {
            player[0].pause();
        } else if (videoIframe && videoIframe.length > 0) {
            videoIframe.attr('src', '')
        }

        videoPageWrapper.hide();
        html.removeClass(hiddenClass);
        body.removeClass(hiddenClass);
    });

    // Reopen video page
    linkShowVideo.on('click', function () {
        // Stop scrolling when video page is visible
        html.addClass(hiddenClass);
        body.addClass(hiddenClass);
        // Show popup video
        videoPageWrapper.show();
    });
}

function toggleHpVideo() {
    const video = $('#bg-video')
    const videoSource = video.find('source')
    const mobileVideo = video.data('mobile')
    const desktopVideo = video.data('desktop')
    videoSource.remove()
    if ($(window).width() <= 768) {
        video.append("<source src='"+mobileVideo+"' type='video/mp4' >");
    } else {
        video.append("<source src='"+desktopVideo+"' type='video/mp4' >");
    }
}

function showVideoPage (videoPageWrapper) {
    if ($('body').hasClass('template-index') && videoPageWrapper.length > 0) {
        return true;
    }
    return false;
}

function disableBtnCheckoutOnCart(el) {
    var $checkbox = $(el);
    if ($checkbox.is(':checked')) {
        $('.btn-checkout-cart').removeAttr('disabled');
    } else {
        $('.btn-checkout-cart').attr('disabled', 'disabled');
    }
}

function disableBtnNewsletterFooter(el) {
    var $checkbox = $(el);
    if ($checkbox.is(':checked')) {
        $('.btn-submit-form-newsletter-footer').removeAttr('disabled');
    } else {
        $('.btn-submit-form-newsletter-footer').attr('disabled', 'disabled');
    }
}

function disableBtnCheckoutOnCartPage(el) {
    var $checkbox = $(el);
    if ($checkbox.is(':checked')) {
        $('.btn-checkout-cart-page').removeAttr('disabled');
    } else {
        $('.btn-checkout-cart-page').attr('disabled', 'disabled');
    }
}

function validateFormNewsletterFooter()
{
    var $form = $('#footer-newsletter');
    if ($form.length == 0) {
        return;
    }
    $form.on('submit', function (e) {
        var email = $('#footer_input_email_newsletter').val(),
            first_name = $('#footer_input_first_name_newsletter').val(),
            last_name = $('#footer_input_email_newsletter').val(),
            countries = $('#footer_select_countries_newsletter').val(),
            accept_newsletter = $('#accept_newsletter').is(':checked');

        if (email == '' || first_name == '' && last_name == '' || countries == '---' || countries == '' || accept_newsletter == false) {
            e.preventDefault();
        }
    });

}

function validateFormNewsletterPopup()
{
    var $form = $('#newsletter-popup');
    if ($form.length == 0) {
        return;
    }
    $form.on('submit', function (e) {
        var email = $('#popup_input_email').val(),
            first_name = $('#popup_input_first_name').val(),
            last_name = $('#popup_input_last_name').val(),
            countries = $('#popup_select_countries').val(),
            accept_newsletter = $('#accept_term_and_conditions_popup_newsletter').is(':checked');

        if (email == '' || first_name == '' && last_name == '' || countries == '---' || countries == '' || accept_newsletter == false) {
            e.preventDefault();
        }
    });

}

function openPopupNewsletter() {
    var btn = $('.btn-submit-form-newsletter-footer');
    if (btn.length <= 0) {
        return;
    }
    btn.on('click', function () {
        $('.NewsletterPopup').attr('aria-hidden', 'false');
    });
}

function hideTaxesLabelonCh() {
    var data = localStorage.getItem('gdprCache');
    var parseData = JSON.parse(data);
    var countryData = JSON.parse(parseData.countryDetection);
    var country = countryData.country;
    if (country !== 'CH' && window.shopId === 51567296670) $('body').addClass('hide-taxes-label');
    if (window.shopId === 59724824753) $('body').addClass('hide-taxes-label');
}

function showSizeOnMouseover() {
  $(".ProductItem").hover( function () { $('.ProductItem__AvailableSize', this).css('visibility','visible') }, function () { $('.ProductItem__AvailableSize', this).css('visibility','hidden') } );
}

function centerProductArrows() {
  if ($(".Product .Product__Slideshow").length == 0) return;
  $(".Product__SlideshowMobileNav").appendTo(".Product .Product__Slideshow");
}